
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insight",
      function () {
        return require("private-next-pages/insight/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insight"])
      });
    }
  